<template>
  <b-modal
    v-model="show"
    :title="`Edit ${label}`"
    @hide="onHide"
    centered
    no-stacking
    size="xl"
  >
    <b-form-group :label="label">
      <!-- Logic to switch input types based on the field -->
      <vue-editor v-if="inputType === 'vueEditor'" :editorToolbar="customToolbarAdmin" v-model="editValue"></vue-editor>

      <b-form-textarea
        v-if="inputType === 'textarea'"
        v-model="editValue"
        rows="4"
        class="form-control"
      />
      <b-form-input
        v-if="inputType === 'text'"
        v-model="editValue"
        :type="inputType"
        class="form-control"
      />
    </b-form-group>

    <template #modal-footer>
      <b-button size="sm" variant="secondary" @click="show = false">Cancel</b-button>
      <b-button size="sm" variant="primary" :disabled="loading" @click="handleSave">
        <b-spinner v-if="loading" small />
        Save Changes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { VueEditor } from "vue2-editor"

export default {
  components: {
    VueEditor
  },
  name: "SingleFieldEdit",
  props: {
    propEditConfig: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    updateFieldKey: {
      type: String,
      default: ""
    },
    baseRecordId: {
      type: [String, Number],
      default: null
    },
    baseRecordKey: {
      type: String,
      default: ""
    },
    currentValue: {
      default: ""
    },
    inputType: {
      type: String,
      default: "text"
    },
    apiFunction: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      editValue: "",
      show: this.value,
      customToolbarAdmin: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [{ "script": "super" }, { "script": "sub" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link", "image", "video", "formula"],
        ["clean"] // remove formatting button
      ]
    }
  },
  watch: {
    value (val) { this.show = val },
    show (val) { this.$emit("input", val) },
    // Reset editValue whenever the modal opens with new data
    currentValue: {
      immediate: true,
      handler (val) { this.editValue = val }
    }
  },
  mounted () {
    console.log("XXXXXXX", this.propEditConfig)
    // this.inputType = this.propEditConfig
  },
  methods: {
    /**
     * onHide
     */
    onHide () {
      this.loading = false
    },
    /**
     * handleSave
     */
    async handleSave () {
      this.loading = true
      try {
        // Construct dynamic payload
        const payload = {
          [this.baseRecordKey]: this.baseRecordId,
          [this.updateFieldKey]: this.editValue // This sets the column name dynamically
        }

        const resp = await this.apiFunction(payload)

        if (resp && resp.resp_status) {
          this.$emit("success", { key: this.updateFieldKey, value: this.editValue })
          this.show = false
        }
        else {
          // You can trigger a toast here or emit an error
          this.$emit("error", resp.resp_msg)
        }
      }
      catch (err) {
        console.error("handleSave: Modal Save Error:", err)
      }
      finally {
        this.loading = false
      }
    }
  }
}
</script>
